import fb from "@bd-core/firebase";
import CONFIG from "./config";

export const getAttributes = () => {
  return fb.get(`${fb.teamAttributesPath}`);
};

export const updateAttributes = (data) => {
  return fb.update(`${fb.teamAttributesPath}`, data);
};

export const getShouldFinishedAttribute = () => {
  return fb.get(`${fb.teamAttributesPath}/shouldFinishAt`);
};

export const updateShouldFinishedAttribute = (data) => {
  return fb.update(`${fb.teamAttributesPath}/shouldFinishAt`, data);
};

export const saveBuildingBlockAnswers = (buildingBlockId, answers) => {
  return fb.update(`${fb.buildingBlocksPath}/${buildingBlockId}`, {
    finalAnswers: answers,
  });
};

export const updateFinalBuildingBlockAnswer = (buildingBlockId, answer) => {
  return fb.update(
    `${fb.buildingBlocksPath}/${buildingBlockId}/finalAnswers`,
    answer,
  );
};

export const getFinalBuildingBlockAnswers = (buildingBlockId) => {
  return fb.get(`${fb.buildingBlocksPath}/${buildingBlockId}/finalAnswers`);
};

export const updateBuildingBlockAnswer = (buildingBlockId, answers) => {
  return fb.update(
    `${fb.buildingBlocksPath}/${buildingBlockId}/answers`,
    answers,
  );
};

export const removeBuildingBlockAnswer = (buildingBlockId, key) => {
  let path = `${fb.buildingBlocksPath}/${buildingBlockId}/answers`;
  if (key) path += `/${key}`;
  return fb.remove(path);
};

export const removeBuildingBlockAnswers = () => {
  return fb.remove(`${fb.buildingBlocksPath}`);
};

export const getBuildingBlockAnswers = (buildingBlockId) => {
  return fb.get(`${fb.buildingBlocksPath}/${buildingBlockId}/answers`);
};

export const maybeUpdateBuildingBlockStatus = (
  buildingBlockId,
  buildingBlockStatus,
) => {
  return fb.update(`${fb.buildingBlocksPath}/${buildingBlockId}`, {
    status: buildingBlockStatus,
  });
};

export const setAllBuildingBlockIsCompleted = (isAllBuildingBlockcompleted) => {
  return fb.update(`${fb.teamAttributesPath}`, {
    allBuildingBlockIsCompleted: isAllBuildingBlockcompleted,
  });
};

export const updatePlayerPageId = (pageId) => {
  return fb.update(`${fb.currentPlayerPath}`, {
    currentPageId: pageId,
  });
};

export const updateProfileFirebase = (data) => {
  return fb.update(fb.currentPlayerPath, data);
};

export const setGameStartedAt = async () => {
  let isStarted = null;
  await fb
    .get(`${fb.teamAttributesPath}/startedAt`)
    .then((snapshot) => {
      isStarted = snapshot.val();
    })
    .catch((error) => {
      console.error(error);
    });
  if (isStarted) return;

  const timerConfig = CONFIG.game_options.timer_config;
  if (!timerConfig.is_enable_timer) return;

  const startedAt = Math.floor(Date.now() / 1000);
  const shouldFinishAt = startedAt + timerConfig.timer_limit * 60;

  return fb.update(`${fb.teamAttributesPath}`, {
    startedAt,
    shouldFinishAt,
  });
};

export const setGameScreenPopup = () => {
  return fb.update(`${fb.teamAttributesPath}`, {
    isGameScreenPopup: true,
  });
};

export const setIsTimeout = async () => {
  let isTimeout = null;
  await fb
    .get(`${fb.teamAttributesPath}/isTimeout`)
    .then((snapshot) => {
      isTimeout = snapshot.val();
    })
    .catch((error) => {
      console.error(error);
    });
  if (isTimeout) return;

  return fb.update(`${fb.teamAttributesPath}`, {
    isTimeout: true,
  });
};

export const updateTimeoutBuildingBlockAnswers = (buildingBlockId, answers) => {
  return fb.update(
    `${fb.buildingBlocksPath}/${buildingBlockId}/timeoutAnswers`,
    answers,
  );
};

export const getTimeoutBuildingBlockAnswers = (buildingBlockId) => {
  return fb.get(`${fb.buildingBlocksPath}/${buildingBlockId}/timeoutAnswers`);
};
